import { render, staticRenderFns } from "./BusinessSetting.vue?vue&type=template&id=a7588356&"
import script from "./BusinessSetting.vue?vue&type=script&lang=js&"
export * from "./BusinessSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7588356')) {
      api.createRecord('a7588356', component.options)
    } else {
      api.reload('a7588356', component.options)
    }
    module.hot.accept("./BusinessSetting.vue?vue&type=template&id=a7588356&", function () {
      api.rerender('a7588356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/BusinessSetting.vue"
export default component.exports